import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (options: IGenericObject) => {
  const { isDropdownOpen, numberOfSublinks } = options;
  return StyleSheet.create({
    defaultLink: {
      display: 'flex',
      justifyContent: 'flex-end',
      cursor: 'pointer',
      height: 'fit-content',
      width: '100%',
      padding: 20,
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 'bold',
      color: palette.white,
      background: palette.darkGrey,
      textDecoration: 'none',
    },

    defaultLinkContent: {
      display: 'flex',
      position: 'relative',
      alignItems: 'center',
      pointerEvents: 'none', // Required to prioritize the entire dropdown link click event

      [children('img')]: {
        position: 'absolute',
        left: '-10px',
        transform: 'translateX(-100%)',
        maxHeight: '60px',
        height: '30px',
      },
    },

    dropdownLinkContainer: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      width: '100%',
      marginBottom: '3px',
    },

    dropdownLinkHeader: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      width: '100%',
      cursor: 'pointer',
      background: palette.grey,
      justifyContent: 'flex-end',
      padding: 20,

      [children('> span')]: {
        fontSize: '16px',
        lineHeight: '20px',
        fontWeight: 'bold',
        color: palette.white,
      },
    },

    dropdownArrowIndicator: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '12px',
      // this is needed so that the arrow doesnt flip which clicking it on tablet and desktop
      [children('span')]: {
        display: 'flex',
        height: 'fit-content',
        width: 'fit-content',
      },

      [media.tablet]: {
        pointerEvents: 'none',
      },
    },

    dropdownContainer: {
      width: '100%',
      // height: dropdownLink height * number of dropdown links
      height: isDropdownOpen ? `calc(${numberOfSublinks * 48}px)` : '0px',
      overflow: 'hidden',
      transition: 'height 0.2s linear',
    },

    dropdownLink: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      fontSize: '14px',
      lineHeight: '18px',
      padding: '15px 20px',
      maxHeight: '48px',
      background: palette.red,
      color: 'inherit',
      textDecoration: 'none',
      ':not(:last-child)': {
        borderBottom: `1px solid ${palette.white}`,
      },
    },

    dropdownLinkContent: {
      display: 'flex',
      position: 'relative',
      alignItems: 'center',
      pointerEvents: 'none', // Required to prioritize the entire dropdown link click event

      [children('img')]: {
        position: 'absolute',
        left: '-10px',
        transform: 'translateX(-100%)',
        maxHeight: '48px',
        height: '30px',
      },
    },
  });
};
